import { Injectable, SecurityContext } from '@angular/core';
import { LoadingController } from '@ionic/angular';

import { RequestService } from './requestService.service';
import { OfflineManager } from './offlineManager.service';
import { CacheCoordinates } from './entities/cacheCoordinates.class';
import { VisitDirectionsEntity } from './entities/visitDirectionsEntity.class';
import { Translate } from './translate';

import * as moment from 'moment';
import { DateTimeFormat } from './entities/constantsExport.class';
import { Geolocation } from '@capacitor/geolocation';
import { BusinessConfigurationMessages, ClockCategory } from '../shared/enumerations.class';
import { NetworkService } from './networkService.service';
import { MobileService } from './mobileLogin-api.service';
import { ClosureMethod, ServiceOrderStatus } from '../shared/enumerations.class';
import { CacheVisit } from './entities/cacheVisit.class';
import { BusinessService } from './businessService.service';
import { AppBase } from 'src/app/base-classes/app-base';
import { NavigationExtras, Router } from '@angular/router';
import { Urls } from 'src/app/pages';
import { DomSanitizer } from '@angular/platform-browser';
import { Session } from 'src/shared/chat/entities/Session';
import { MomentFormats } from 'src/shared/entities/momentFormats.class';
import { ServiceEntity } from 'src/shared/entities/service.entity';
import { NewRelicService } from './newrelic.service';

@Injectable()
export class CommonService extends AppBase {
    constructor(
        public loading: LoadingController,
        private requestService: RequestService,
        private offlineManager: OfflineManager,
        private networkService: NetworkService,
        private mobileService: MobileService,
        private businessService: BusinessService,
        private router: Router,
        private sanitizer: DomSanitizer,
        public session: Session,
        private newRelicService: NewRelicService,
    ) {
        super(loading);
        this.initLoader();

        this.mobileAppButtonShowAuthInfo = this.mobileService.hasPermission(BusinessConfigurationMessages.MobileAppButtonShowAuthInfo);
        this.showStartVisitOnlyIfThevlientDocumentsHaveBeenReviewed = this.mobileService.hasPermission(BusinessConfigurationMessages.ShowStartVisitOnlyIfThevlientDocumentsHaveBeenReviewed);
    }
    mobileAppButtonShowAuthInfo: boolean = false;
    showStartVisitOnlyIfThevlientDocumentsHaveBeenReviewed: boolean = false;

    updateCacheWithCoordinates(latitude, longitude, timestamp, isArrival): Promise<any> {
        return new Promise<any>(resolve => {
            if (isArrival) {
                this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates = new CacheCoordinates(latitude, longitude, timestamp);
            } else {
                this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates = new CacheCoordinates(latitude, longitude, timestamp);
            }
            this.offlineManager.updateCacheVisit().then(resp => {
                resolve(resp);
            });
            this.newRelicService.recordBreadcrumb('Update_cache_With_Coordinates', {
                service: 'commonService',
                methodName: 'updateCacheWithCoordinates(latitude, longitude, timestamp, isArrival)',
                IsArrival: isArrival,
                latitude: latitude,
                longitude: longitude,
                TimeStampParam: timestamp,
                ProvidedArrivalCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude,
                ProvidedArrivalCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude,
                ProvidedDepartureCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Latitude,
                ProvidedDepartureCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Longitude,
                LastLocationLatitude: this.mobileService.lastLocation.Latitude,
                LastLocationLongitude: this.mobileService.lastLocation.Longitude,
                LastLocationTimeStamp: this.mobileService.lastLocation.TimeStamp,
                isOnline: this.networkService.userIsOnline2(),
                timestamp: Date.now()
            });
            if (this.networkService.userIsOnline2()) {
                this.requestService.saveProvidedCoordinates(this.offlineManager.sessionCurrentVisit.ServiceOrderId, latitude, longitude, isArrival);

                this.offlineManager.getCacheData().then(data => {
                    var visits = data.Visits;
                    visits = this.sortVisits(visits);

                    if (localStorage.getItem(this.requestService.visitSyncFailedKey) != "true") {
                        this.requestService.sendCacheForSync(data).then(result => {
                            if (result == 1) {

                                this.offlineManager.clearLocationCacheData();
                            }
                        });
                    }
                });
            }
        });
    }

    coordinatesAreRefused(isArrival: boolean = false) {
        if (isArrival) {
            if ((this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude == 0 ||
                this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude == -1) &&
                (this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude == 0 ||
                    this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude == -1)) {
                this.newRelicService.recordBreadcrumb('Coordinates_Are_Refused', {
                    service: 'commonService',
                    methodName: 'coordinatesAreRefused(isArrival)',
                    IsArrival: isArrival,
                    ProvidedArrivalCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude,
                    ProvidedArrivalCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude,
                    ProvidedDepartureCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Latitude,
                    ProvidedDepartureCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Longitude,
                    LastLocationLatitude: this.mobileService.lastLocation.Latitude,
                    LastLocationLongitude: this.mobileService.lastLocation.Longitude,
                    LastLocationTimeStamp: this.mobileService.lastLocation.TimeStamp,
                    isOnline: this.networkService.userIsOnline2(),
                    timestamp: Date.now()
                });
                return true;
            } else {
                return false;
            }
        } else {
            if ((this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Latitude == 0 ||
                this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Latitude == -1) &&
                (this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Longitude == 0 ||
                    this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Longitude == -1)) {
                this.newRelicService.recordBreadcrumb('Coordinates_Are_Refused', {
                    service: 'commonService',
                    methodName: 'coordinatesAreRefused(isArrival)',
                    IsArrival: isArrival,
                    ProvidedArrivalCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude,
                    ProvidedArrivalCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude,
                    ProvidedDepartureCoordinatesLatitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Latitude,
                    ProvidedDepartureCoordinatesLongitude: this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates.Longitude,
                    LastLocationLatitude: this.mobileService.lastLocation.Latitude,
                    LastLocationLongitude: this.mobileService.lastLocation.Longitude,
                    LastLocationTimeStamp: this.mobileService.lastLocation.TimeStamp,
                    isOnline: this.networkService.userIsOnline2(),
                    timestamp: Date.now()
                });
                return true;
            }
            else {
                return false;
            }
        }
    }

    hasCoordinatesForUpload: boolean = false;
    numberOfGPSTries: number = 0;
    locationIntervalForUpload: any;
    refreshGPSAndUploadCoordinates(isArrival: boolean) {
        this.hasCoordinatesForUpload = false;
        this.numberOfGPSTries = 0;
        clearInterval(this.locationIntervalForUpload);

        if (!this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates) {
            this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates = new CacheCoordinates(0, 0, 0);
        }
        if (this.coordinatesAreRefused(isArrival)) {
            this.getAccurateLocation();

            this.mobileService.getLocation(this.networkService.userIsOnline2()).then(data => {
                var accurateLocation = new CacheCoordinates(this.mobileService.lastLocation.Latitude, this.mobileService.lastLocation.Longitude, data.timestamp);
                this.offlineManager.logLocationInCache(accurateLocation).then(() => {
                    if (data && data.coords) {
                        this.mobileService.lastLocation = new CacheCoordinates(accurateLocation.Latitude, accurateLocation.Longitude, data.timestamp);
                        this.updateCacheWithCoordinates(this.mobileService.lastLocation.Latitude, this.mobileService.lastLocation.Longitude, data.timestamp, isArrival);
                        this.hasCoordinatesForUpload = true;
                    }
                }, reject => {
                    this.commonHideLoader();
                    this.offlineManager.logLocationInCache(null);
                });
            }).catch(e => {
                this.commonHideLoader();
                this.hasCoordinatesForUpload = false;
                console.log("error " + e);
            });
            this.numberOfGPSTries = 1;
            this.getAndCheckLocation(true);
        }

        this.setLocationInterval(isArrival);
    }

    setLocationInterval(isArrival: boolean = false) {
        this.locationIntervalForUpload = setInterval(() => {
            this.numberOfGPSTries++;
            if (this.numberOfGPSTries < 12) {
                if (this.coordinatesAreRefused(isArrival)) {
                    this.hasCoordinatesForUpload = false;
                    this.getAndCheckLocation(true);
                } else {
                    this.hasCoordinatesForUpload = true;
                    clearInterval(this.locationIntervalForUpload);
                }
            } else {
                clearInterval(this.locationIntervalForUpload);
            }
        }, 15000);
    }

    refreshGPS(isArrival: boolean, isPressed: boolean = false) {
        this.showLoader();
        this.mobileService.gpsCountDown();
        this.getAccurateLocation();
        this.mobileService.getLocation(this.networkService.userIsOnline2(), isArrival, isPressed).then(data => {
            var accurateLocation = new CacheCoordinates(this.mobileService.lastLocation.Latitude, this.mobileService.lastLocation.Longitude, data.timestamp);
            this.offlineManager.logLocationInCache(accurateLocation).then(() => {
                if (data && data.coords) {
                    this.mobileService.lastLocation = new CacheCoordinates(accurateLocation.Latitude, accurateLocation.Longitude, accurateLocation.TimeStamp);
                    this.updateCacheWithCoordinates(accurateLocation.Latitude, accurateLocation.Longitude, accurateLocation.TimeStamp, isArrival).then(response => {
                        this.commonHideLoader();
                        this.refreshGPSWarnings(isArrival);
                    });
                    this.hasCoordinates = true;
                } else {
                    this.locationWarning = Translate.getTranslation("GPSNotCaptured3");
                    this.commonHideLoader();
                    this.refreshGPSWarnings(isArrival);
                }
            }, reject => {
                this.offlineManager.logLocationInCache(null);
                this.commonHideLoader();
            });
        }).catch(error => {
            this.commonHideLoader();
            if (this.mobileService.gpsRetries >= this.mobileService.gpsRetryLimit && error != 1) {
                this.disableAcceptTime = false;
                clearInterval(this.locationInterval);
            }
        });
        this.locationIntervalRetries = setInterval(() => {
            this.commonHideLoader();
            clearInterval(this.locationIntervalRetries);
        }, 180000);
    }

    hasCoordinates: boolean = true;
    disableAcceptTime: boolean = true;
    locationNotCloseEnough: boolean = false;
    locationWarning: string = "";
    locationInterval: any;
    locationIntervalRetries: any;
    resetDefaultArrivalOrDepartureValues() {
        this.hasCoordinates = true;
        this.disableAcceptTime = true;
        this.locationNotCloseEnough = false;
        this.locationWarning = "";
        clearInterval(this.locationInterval);
        clearInterval(this.locationIntervalRetries);
    }

    setGPSWarnings(isArrival: boolean) {
        if (this.offlineManager.sessionCurrentVisit !== undefined) {
            if (!this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates) {
                this.offlineManager.sessionCurrentVisit.ProvidedDepartureCoordinates = new CacheCoordinates(0, 0, 0);
            }

            if (this.coordinatesAreRefused(isArrival)) {
                this.showLoader();
                this.hasCoordinates = false;
                this.disableAcceptTime = true;
                this.locationWarning = Translate.getTranslation("ConfirmingLocation");

                this.getLocationAtInterval(isArrival);
                if (this.coordinatesAreRefused(isArrival)) {
                    this.locationInterval = setInterval(() => {
                        this.getLocationAtInterval(isArrival);
                        if (this.mobileService.gpsRetryLimit == 0) clearInterval(this.locationInterval);
                    }, this.mobileService.gpsRetryInterval * 1000);
                }
            } else {
                this.refreshGPSWarnings(isArrival);
            }
        }
    }
    refreshGPSWarnings(isArrival: boolean) {
        var acceptOnlyInconfiguredRange = this.mobileService.hasPermission(BusinessConfigurationMessages.ReportArrivalDepartureOnlyIfGPSWithinRange);
        this.getAccurateLocation();
        if (this.coordinatesAreRefused(isArrival)) {
            this.hasCoordinates = false;
            if (acceptOnlyInconfiguredRange && !this.offlineManager.sessionCurrentVisit.DisregardLocationWarnings) {
                this.disableAcceptTime = true;
            } else {
                this.disableAcceptTime = false;
            }
        } else {
            if (this.networkService.userIsOnline2()) {
                this.requestService.checkGpsCoordinates(this.offlineManager.sessionCurrentVisit.ServiceOrderId, this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates, isArrival).then(resp => {
                    if (resp) {
                        this.disableAcceptTime = false;
                        this.hasCoordinates = true;
                        this.locationNotCloseEnough = false;
                    } else {
                        this.disableAcceptTime = true;
                        this.hasCoordinates = false;
                        this.locationNotCloseEnough = true;
                        this.locationWarning = Translate.getTranslation("LocationNotCloseEnough");
                    }
                });
            } else {
                if (this.businessService.checkGpsCoordinates(this.offlineManager.sessionCurrentVisit, this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates, isArrival)) {
                    this.disableAcceptTime = false;
                    this.hasCoordinates = true;
                    this.locationNotCloseEnough = false;
                } else {
                    this.disableAcceptTime = true;
                    this.hasCoordinates = false;
                    this.locationNotCloseEnough = true;
                    this.locationWarning = Translate.getTranslation("LocationNotCloseEnough");
                }
            }
        }
    }
    getLocationAtInterval(isArrival: boolean) {
        if (this.coordinatesAreRefused(isArrival) && !this.offlineManager.sessionCurrentVisit.DisregardLocationWarnings) {
            var acceptOnlyInconfiguredRange = this.mobileService.hasPermission(BusinessConfigurationMessages.ReportArrivalDepartureOnlyIfGPSWithinRange);
            if (acceptOnlyInconfiguredRange) {
                this.locationWarning = Translate.getTranslation("GPSNotCaptured");
            } else {
                this.locationWarning = Translate.getTranslation("GPSNotCaptured2");
            }
            this.refreshGPS(isArrival);
        } else {
            this.hasCoordinates = true;
        }
        this.commonHideLoader();
        this.refreshGPSWarnings(isArrival);
    }

    getActualTimeAndClosureMethod(flow: number) {
        return new Promise<OfflineTime>(resolve => {
            if (this.offlineManager.uptimeTolerance > 0 && this.mobileService.isCordova()) {
                return this.mobileService.getActualTime(this.offlineManager.sessionCurrentVisit.PatientTime, this.offlineManager.sessionCurrentVisit.PatientZone, true, this.offlineManager.sessionCurrentVisit.PatientServiceOrderId, flow).then(result => {
                    var offlineTime: OfflineTime = new OfflineTime(result.time, ClosureMethod.Offline, flow);
                    resolve(offlineTime);
                });
            } else {
                var offlineTime: OfflineTime = new OfflineTime(moment().format(DateTimeFormat), ClosureMethod.PhoneTime, -flow);
                resolve(offlineTime);
            }
        });
    }

    getAndCheckLocation(isArrival, updateNoLocation: boolean = false) {
        var currDate = moment();
        this.getAccurateLocation();
        var lastLocationTime = moment(this.mobileService.lastLocation.TimeStamp);
        var accurateLocation = new CacheCoordinates(this.mobileService.lastLocation.Latitude, this.mobileService.lastLocation.Longitude, this.mobileService.lastLocation.TimeStamp);
        var result = currDate.diff(lastLocationTime, 'seconds')

        this.newRelicService.recordBreadcrumb('Get_And_Check_Location', {
            service: 'commonService',
            methodName: 'getAndCheckLocation(sArrival, updateNoLocation)',
            IsArrival: isArrival,
            currDate: currDate,
            LastLocationTime: lastLocationTime,
            LastLocationLatitude: this.mobileService.lastLocation.Latitude,
            LastLocationLongitude: this.mobileService.lastLocation.Longitude,
            LastLocationTimeStamp: this.mobileService.lastLocation.TimeStamp,
            Result: result,
            isOnline: this.networkService.userIsOnline2(),
            timestamp: Date.now()
        });

        if (result > 180 && updateNoLocation) {
            this.updateCacheWithCoordinates(-1, -1, 0, isArrival);
        } else {
            this.updateCacheWithCoordinates(accurateLocation.Latitude, accurateLocation.Longitude, this.mobileService.lastLocation.TimeStamp, isArrival);
        }
    }

    formatNumber(nr) {
        return (nr < 10 ? "0" : "") + nr;
    }

    formatClock(millisec, format24Hours: boolean = true) {
        var t = parseInt((millisec / 1000) + "");

        var minutes = parseInt((t / 60) + "") % 60;

        var hours = parseInt((t / 60 / 60) + "") % 24;

        if (format24Hours) {
            return this.formatNumber(hours) + ":" + this.formatNumber(minutes);
        } else {
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            return hours + ":" + this.formatNumber(minutes) + ampm;
        }
    }

    reportCarePlanItems(visit, isFrom: CarePlanItemIsFrom) {
        if (visit != null) {
            this.offlineManager.sessionCurrentVisit = new CacheVisit(visit);
            this.offlineManager.sessionCurrentVisit.ServiceOrderId = (visit.ServiceOrderId !== undefined ? visit.ServiceOrderId : visit.serviceOrderId);
        }
        const navigationExtras: NavigationExtras = {
            state: {
                "isInArrival": isFrom.isInArrival,
                "isFromArrival": isFrom.isFromArrival,
                "isFromVisitHistory": isFrom.isFromVisitHistory,
                "soId": visit.ServiceOrderId
            }
        };
        this.router.navigate([Urls.ReportCarePlansPage], navigationExtras);
    }

    clockOut(visit) {
        if (this.offlineManager.sessionCurrentVisit.Status == ServiceOrderStatus.Departure) {
            const navigationExtras: NavigationExtras = {
                state: {
                    "soId": visit.ServiceOrderId
                }
            };
            if (this.mobileService.hasPermission(BusinessConfigurationMessages.AllowRecordCarePlanItems)) {
                this.newRelicService.recordBreadcrumb('Navigate_to_ReportCarePlansPage', {
                    service: 'commonService',
                    methodName: 'clockOut(visit)',
                    PatientId: visit.PatientId,
                    AllowRecordCarePlanItems: this.mobileService.hasPermission(BusinessConfigurationMessages.AllowRecordCarePlanItems),
                    patientName: visit.PatientFirstName + ' ' + visit.PatientLastName,
                    AppointmentDate: visit.AppointmentDate,
                    Status: visit.Status,
                    ArrivalTime: visit.ArrivalTime,
                    Duration: visit.Duration,
                    isContiguous: visit.ContiguousVisits.length > 0,
                    DepartureTime: visit.DepartureTime,
                    ServiceOrderId: visit.ServiceOrderId,
                    ServiceTypeName: visit.ServiceTypeName,
                    ServiceTypeID: visit.ServiceTypeID,
                    isOnline: this.networkService.userIsOnline2(),
                    timestamp: Date.now()
                });
                this.router.navigate([Urls.ReportCarePlansPage], navigationExtras);
            } else if (this.offlineManager.sessionCurrentVisit.AuthorizedToRecordTrips) {
                this.newRelicService.recordBreadcrumb('Navigate_to_RecordTripsPage', {
                    service: 'commonService',
                    methodName: 'clockOut(visit)',
                    PatientId: visit.PatientId,
                    AuthorizedToRecordTrips: this.offlineManager.sessionCurrentVisit.AuthorizedToRecordTrips,
                    patientName: visit.PatientFirstName + ' ' + visit.PatientLastName,
                    AppointmentDate: visit.AppointmentDate,
                    Status: visit.Status,
                    ArrivalTime: visit.ArrivalTime,
                    Duration: visit.Duration,
                    isContiguous: visit.ContiguousVisits.length > 0,
                    DepartureTime: visit.DepartureTime,
                    ServiceOrderId: visit.ServiceOrderId,
                    ServiceTypeName: visit.ServiceTypeName,
                    ServiceTypeID: visit.ServiceTypeID,
                    isOnline: this.networkService.userIsOnline2(),
                    timestamp: Date.now()
                });
                this.router.navigate([Urls.RecordTripsPage], navigationExtras);
            } else if (this.mobileService.hasPermission(BusinessConfigurationMessages.AllowReportExpenses)) {
                this.newRelicService.recordBreadcrumb('Navigate_to_ReportExpensesPage', {
                    service: 'commonService',
                    methodName: 'clockOut(visit)',
                    PatientId: visit.PatientId,
                    AllowReportExpenses: this.mobileService.hasPermission(BusinessConfigurationMessages.AllowReportExpenses),
                    patientName: visit.PatientFirstName + ' ' + visit.PatientLastName,
                    AppointmentDate: visit.AppointmentDate,
                    Status: visit.Status,
                    ArrivalTime: visit.ArrivalTime,
                    Duration: visit.Duration,
                    isContiguous: visit.ContiguousVisits.length > 0,
                    DepartureTime: visit.DepartureTime,
                    ServiceOrderId: visit.ServiceOrderId,
                    ServiceTypeName: visit.ServiceTypeName,
                    ServiceTypeID: visit.ServiceTypeID,
                    isOnline: this.networkService.userIsOnline2(),
                    timestamp: Date.now()
                });
                this.router.navigate([Urls.ReportExpensesPage], navigationExtras);
            } else
                if (!this.offlineManager.sessionCurrentVisit.HideErrandReportingOnMobileApp && this.mobileService.hasPermission(BusinessConfigurationMessages.ShowErrandMilesButtonOnMobileApp) && this.mobileService.hasPermission(BusinessConfigurationMessages.RecordErrandMiles)) {
                    const navigationExtras: NavigationExtras = {
                        state: {
                            "visitDate": this.offlineManager.sessionCurrentVisit.AppointmentDate,
                            "isFromCarePlan": true,
                            "soId": visit.ServiceOrderId
                        }
                    };
                    this.router.navigate([Urls.RecordErrandMilesPage], navigationExtras);
                } else {
                    this.newRelicService.recordBreadcrumb('Navigate_to_VisitSignaturePage', {
                        service: 'commonService',
                        methodName: 'clockOut(visit)',
                        PatientId: visit.PatientId,
                        patientName: visit.PatientFirstName + ' ' + visit.PatientLastName,
                        AppointmentDate: visit.AppointmentDate,
                        Status: visit.Status,
                        ArrivalTime: visit.ArrivalTime,
                        Duration: visit.Duration,
                        isContiguous: visit.ContiguousVisits.length > 0,
                        DepartureTime: visit.DepartureTime,
                        ServiceOrderId: visit.ServiceOrderId,
                        ServiceTypeName: visit.ServiceTypeName,
                        ServiceTypeID: visit.ServiceTypeID,
                        isOnline: this.networkService.userIsOnline2(),
                        timestamp: Date.now()
                    });
                    this.router.navigate([Urls.VisitSignaturePage], navigationExtras);
                }
        } else {
            const navigationExtras: NavigationExtras = {
                state: {
                    "soId": visit.ServiceOrderId
                }
            };
            this.getAndCheckLocation(false, true);
            this.newRelicService.recordBreadcrumb('Navigate_to_ReportDeparturePage', {
                service: 'commonService',
                methodName: 'clockOut(visit)',
                PatientId: visit.PatientId,
                patientName: visit.PatientFirstName + ' ' + visit.PatientLastName,
                AppointmentDate: visit.AppointmentDate,
                Status: visit.Status,
                ArrivalTime: visit.ArrivalTime,
                Duration: visit.Duration,
                isContiguous: visit.ContiguousVisits.length > 0,
                DepartureTime: visit.DepartureTime,
                ServiceOrderId: visit.ServiceOrderId,
                ServiceTypeName: visit.ServiceTypeName,
                ServiceTypeID: visit.ServiceTypeID,
                isOnline: this.networkService.userIsOnline2(),
                timestamp: Date.now()
            });
            this.router.navigate([Urls.ReportDeparturePage], navigationExtras);
        }
    }

    showDetails(visit) {
        this.offlineManager.sessionCurrentVisit = new CacheVisit(visit);
        const navigationExtras: NavigationExtras = {
            state: {
                "currentVisit": visit,
                //"visitList": this.visitList
            }
        };
        this.router.navigate([Urls.VisitDetailsPage], navigationExtras);
    }

    syncVisitWarning = false;
    finishDeparture(url: Urls, serviceOrderId: number) {
        const navigationExtras: NavigationExtras = {
            state: {

                "soId": serviceOrderId
            }
        };
        this.syncVisitWarning = false;
        if (this.networkService.userIsOnline2()) {
            this.offlineManager.updateCacheVisit().then(() => {
                this.offlineManager.getCacheData().then(data => {
                    var visits = data.Visits;
                    visits = this.sortVisits(visits);

                    this.sendCacheDataForSync(data, visits, visits[visits.length - 1].AppointmentDate, serviceOrderId).then((result) => {
                        if (!result) this.syncVisitWarning = true;
                        this.commonHideLoader();
                        this.router.navigate([url], navigationExtras);
                    });

                    this.mobileService.syncWorkerCoordinates();
                })
            })
        }
        else {
            this.offlineManager.updateCacheVisit().then(() => {
                this.commonHideLoader();
                this.router.navigate([url], navigationExtras);
            })
        }
    }

    sortVisits(visits: CacheVisit[]) {
        return visits ? visits.sort(function (v1, v2) {
            if (moment(v1.AppointmentDate, MomentFormats.momentFormats).isAfter(moment(v2.AppointmentDate, MomentFormats.momentFormats), "date")) {
                return 1;
            }
            if (moment(v1.AppointmentDate, MomentFormats.momentFormats).isBefore(moment(v2.AppointmentDate, MomentFormats.momentFormats), "date")) {
                return -1;
            }
            return 0;
        }) : [];
    }

    sanitizeInput(input) {
        try {
            input = this.sanitizer.sanitize(SecurityContext.HTML, input);
        }
        catch (ex) {
            input = "";
        }
        return input;
    }

    sendCacheDataForSync(data: any, visits: CacheVisit[], endDate: string, serviceOrderId: number) {
        return new Promise<boolean>(resolve => {
            this.requestService.sendCacheForSync(data).then(result => {
                if (result == 1) {
                    this.offlineManager.clearLocationCacheData();
                    this.requestService.getVisitUpdatesForCache(serviceOrderId, visits[0].AppointmentDate, endDate).then(visit => {
                        if (visit != null) {
                            this.offlineManager.sessionCurrentVisit = new CacheVisit(visit);
                        } else {
                            resolve(false);
                        }
                        this.offlineManager.updateCacheVisit_AfterSync(this.offlineManager.sessionCurrentVisit).then(() => {
                            resolve(true);
                        });
                    });
                } else {
                    this.offlineManager.updateCacheVisit().then(() => {
                        resolve(false);
                    });
                }
            });
        });
    }

    getVisit(serviceOrderID) {
        if (serviceOrderID == 0 || !localStorage.getItem('visits'))
            return null;

        let visits = JSON.parse(localStorage.getItem('visits'));
        for (let index = 0; index < visits.length; index++) {
            const element = visits[index];
            if (element && element.ServiceOrderID == serviceOrderID)
                return element;
        }

        return null;
    }

    clearLocalStorage() {
        localStorage.clear();
    }

    addVisit(docVisits) {
        try {
            docVisits = docVisits.d;

            if (!localStorage.getItem('visits')) {
                localStorage['visits'] = docVisits;
                const docss = JSON.parse(docVisits);
                return docss[0];
            }

            let v = JSON.parse(docVisits); // Server visits
            let visits = JSON.parse(localStorage.getItem('visits')); // Local visits

            if (v && v.length > 0) {
                const newVisit = v[0];
                const index = visits.findIndex((v) => v && v.ServiceOrderID === newVisit.ServiceOrderID);

                if (index !== -1) {
                    const existingVisit = visits[index];

                    // Step 1: merge server and local documents with logic
                    const mergedDocuments = newVisit.Documents.filter(serverDoc => {
                        const localDoc = existingVisit.Documents?.find(d => d.ServiceOrderDocumentID === serverDoc.ServiceOrderDocumentID);

                        // If local doc exists and has a protected status → use local, skip server version
                        if (localDoc && (localDoc.Status === 'Incomplete' || localDoc.Status === 'Completed')) {
                            return false; // skip adding server version, local one will be preserved later
                        }

                        return true; // allow adding server version
                    });

                    // Step 2: collect local docs that should be preserved
                    const preservedLocalDocs = existingVisit.Documents?.filter(localDoc => {
                        return localDoc.Status === 'Incomplete' || localDoc.Status === 'Completed';
                    }) || [];

                    // Step 3: final merged doc list (no duplicates, full respect of protected docs)
                    console.log("documents local for serviceid = " +existingVisit.ServiceOrderID,preservedLocalDocs)
                    console.log("documents mergedDocuments for serviceid = " +existingVisit.ServiceOrderID,mergedDocuments)
                    newVisit.Documents = [...preservedLocalDocs, ...mergedDocuments];
                    visits[index] = newVisit;
                } else {
                    visits.push(newVisit); // New visit, no merging needed
                }

                visits = visits.filter(v => v != null);
                localStorage['visits'] = JSON.stringify(visits);
            }

            return v[0];
        } catch (error) {
            console.log("addVisit error : " + error)
        }
    }

    retrieveDataForMaps() {
        let visit = this.offlineManager.sessionCurrentVisit;
        let now = moment().format(DateTimeFormat);
        return new Promise<VisitDirectionsEntity>(resolve => {
            this.requestService.getDataForMapDirections(visit, now, now, now).then(data => {
                resolve(data);
            })
        })
    }

    uploadTimesheets(ServiceOrderId) { //this.visitList[i].ServiceOrderId
        const navigationExtras: NavigationExtras = {
            state: {
                "params": ServiceOrderId
            }
        };

        this.router.navigate([Urls.UploadTimesheetsPage], navigationExtras);
    }

    async commonShowLoader() {
        await this.initLoader();
        this.showLoader();
    }
    commonHideLoader() {
        this.hideLoader();
    }

    async getPatientAuthorizations(patientId: number, todayDate: string) {
        return new Promise<any>(resolve => {
            this.requestService.getPatientAuthorization(patientId, todayDate.split("T")[0]).then(data => {
                var serviceInfos: Array<ServiceEntity> = data.map(function (e) {
                    var totalUnits = e.TotalAuthorizedUnits;
                    var totalUsed = e.AuthorizedUnitsUsed;
                    return new ServiceEntity(e.TotalAuthorizedUnits, e.AuthorizedUnitsUsed, e.AuthorizedUnitsLeft, e.UseOrLoseBy, e.ContractType, e.ServiceType, e.ContractStart, e.UnitDuration);
                });
                var serviceInfoArray: Array<any> = serviceInfos;
                var serviceInfo: Array<any> = [];

                for (let s of serviceInfoArray) {
                    s.totalUnits = this.mobileService.convertToHoursMins(s.totalUnits);
                    s.totalUsed = this.mobileService.convertToHoursMins(s.totalUsed);
                    s.totalLeft = this.mobileService.convertToHoursMins(s.totalLeft);
                    serviceInfo.push(s);
                }

                resolve(serviceInfo);
            }).catch(e => { console.log(e); });
        });
    }

    async getAccurateLocation() {
        const position = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
        this.newRelicService.recordBreadcrumb('Get_Accurate_Location', {
            service: 'commonService',
            methodName: 'getAccurateLocation()',
            Latitude: position.coords.latitude,
            Longitude: position.coords.longitude,
            LastLocationLatitude: this.mobileService.lastLocation.Latitude,
            LastLocationLongitude: this.mobileService.lastLocation.Longitude,
            isOnline: this.networkService.userIsOnline2(),
            timestamp: Date.now()
        });
        this.mobileService.lastLocation.Latitude = position.coords.latitude;
        this.mobileService.lastLocation.Longitude = position.coords.longitude;


        // this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Latitude = position.coords.latitude;
        // this.offlineManager.sessionCurrentVisit.ProvidedArrivalCoordinates.Longitude = position.coords.longitude;
    }
}

export class OfflineTime {
    actualTime: string;
    closureMethod: number;
    flow: number;

    constructor(
        actualTime: string,
        closureMethod: number,
        flow: number
    ) {
        this.actualTime = actualTime;
        this.closureMethod = closureMethod;
        this.flow = flow;
    }
}

export class CarePlanItemIsFrom {
    isInArrival: boolean = false;
    isFromArrival: boolean = false;
    isFromVisitHistory: boolean = false;

    constructor(
        obj: CarePlanItemIsFrom
    ) {
        if (obj == null) {
            this.isInArrival = false;
            this.isFromArrival = false;
            this.isFromVisitHistory = false;
        } else {
            this.isInArrival = obj.isInArrival;
            this.isFromArrival = obj.isFromArrival;
            this.isFromVisitHistory = obj.isFromVisitHistory;
        }
    }
}